import { defineComponent as _defineComponent } from 'vue';
import {} from "@/api";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetHash',
    props: {
        hash: null
    },
    setup(__props) {
        return { __sfc: true, };
    }
});
